<div main class="container flex flex-row justify-end items-start max-w-full">
  <div
    class="left-container flex flex-col justify-start items-start"
    [class.is-mobile]="isMobileDevice"
  >
    <div class="logo-wrapper">
      <img src="/assets/img/logo_viessmann.svg" />
      <div class="dot-container">
        <img src="/assets/img/viguide-name-black.svg" alt="ViGuide" />
      </div>
    </div>
    <div class="data-wrapper">
      <div class="flex flex-col justify-start items-start">
        <div class="header flex flex-col gap-[24px] gt-lg:gap-[16px] justify-start items-start">
          <div class="home-subtitle">{{ '+HOME.HOME.SUBTITLE' | translate }}</div>
          <div class="home-description" data-at-description>
            {{ '+HOME.HOME.DESCRIPTION' | translate }}
          </div>
        </div>
        <div
          class="buttons-container flex flex-col gap-[8px] justify-start items-start xs:items-center"
        >
          <div class="combined-buttons">
            <dsw-login
              gtm="onAuthentication"
              [isLoggedIn]="authStore.authenticated$ | async"
              (loginEvent)="authStore.startLogin()"
              [locale]="locale"
            ></dsw-login>

            <button
              class="try-demo"
              right
              mat-stroked-button
              gtm="onDemoRun"
              (click)="authStore.runDemo()"
            >
              {{ 'GENERAL.BUTTON.DEMO' | translate }}
            </button>
          </div>
          <div class="register-btn">
            <a
              right
              data-at-register-btn
              mat-flat-button
              [href]="registerUrl"
              gtm="onRegister"
              class="register-link"
            >
              {{ 'GENERAL.BUTTON.REGISTER' | translate }}
              <mat-icon class="arrow-icon" iconPositionEnd>arrow_forward</mat-icon>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="!isMobileDevice" class="img-container lt-md:!hidden"></div>
</div>
